<template>
	<sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
		<template slot="table-body">
			<data-analysis-elaborazioni-batchList-component ref="cmpDataAnalysisElaborazioniBatchListComponent" @afterLoadData="onAfterLoadData"></data-analysis-elaborazioni-batchList-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import DataAnalysisElaborazioniBatchListComponent from "../components/DataAnalysisElaborazioniBatchListComponent.vue";
export default {
	components: { SaPageLayout, DataAnalysisElaborazioniBatchListComponent },
	data() {
		return {
			btnNewVisible: true,
			pathResource: "",
			linkedit: "/dataanalysisquery",
			showModalLoading: false,
			listKey: 0,
		};
	},
	mounted() {
		//let me = this;
		//me.loadData();
	},
	methods: {
		loadData() {
			let me = this;
			me.showModalLoading = true;
			me.$refs.cmpDataAnalysisElaborazioniBatchListComponent.loadData();
		},
		onRefresh() {
			let me = this;
			me.loadData();
		},
		onAfterLoadData() {
			let me = this;
			me.showModalLoading = false;
		},
	},
};
</script>

<style></style>
